var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CkanSharedTraits from "./CkanSharedTraits";
import CatalogMemberReferenceTraits from "./CatalogMemberReferenceTraits";
import mixTraits from "../mixTraits";
import MappableTraits from "./MappableTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import { traitClass } from "../Trait";
let CkanCatalogItemTraits = (_dec = traitClass({
  description: "Creates a calalog item that references a ckan item.\n\n  <strong>Note:</strong> \n  <li>The property <code>resourceId</code> in the example below is a Ckan resource Id that references a geospatial type (wms) data.</li>",
  example: {
    url: "https://discover.data.vic.gov.au",
    type: "ckan-item",
    resourceId: "22b8cf52-4583-4609-a3da-a6e1805829d9",
    name: "A Ckan Item (WMS)",
    id: "some id"
  }
}), _dec2 = primitiveTrait({
  name: "Dataset ID",
  description: "The CKAN ID of the dataset.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Magda Record Data",
  description: "The Resource ID of the dataset to use",
  type: "string"
}), _dec(_class = (_class2 = class CkanCatalogItemTraits extends mixTraits(UrlTraits, MappableTraits, CkanSharedTraits, CatalogMemberReferenceTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "datasetId", _descriptor, this);
    _initializerDefineProperty(this, "resourceId", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "datasetId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "resourceId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { CkanCatalogItemTraits as default };